import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility } from '@livable/saas-react-components';
import { ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const Utility = observer(_ref => {
  let _ref$utility = _ref.utility,
    utility = _ref$utility === void 0 ? {} : _ref$utility,
    unitIndex = _ref.unitIndex,
    utilityId = _ref.utilityId;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const utilityData = getUtility(utility.title);
  const _useState = useState(store.addNewProperty.unitSetup.getOptOutUtilityIds(unitIndex, utilityId) ? 'exclude' : 'include'),
    _useState2 = _slicedToArray(_useState, 2),
    billing = _useState2[0],
    setBilling = _useState2[1];
  const handleBillingChange = (e, value) => {
    if (value) {
      store.addNewProperty.unitSetup.changeOptOutUtilityIds(unitIndex, utilityId);
      setBilling(value);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.utility
  }, utilityData.icon({
    svgType: 'static'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityName
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, utility.title), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, utility.utilityProviderName)), /*#__PURE__*/React.createElement("div", {
    className: classes.billing
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: billing,
    onChange: handleBillingChange,
    size: isMobile ? 'small' : '',
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "include"
  }, t('add_new_property_flow.takes_part_in_ratio_billing')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "exclude"
  }, t('add_new_property_flow.exclude_from_calculations')))));
});
Utility.propTypes = {
  utility: PropTypes.shape({
    title: PropTypes.string,
    isSubmetered: PropTypes.bool
  })
};